var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"setting-container"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('jBoardAssignee',{ref:"refBoardAssignee",attrs:{"board-id":_vm.board.id,"form-id":_vm.board ? _vm.board.input_value : 0}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b7fa827","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/tabs/jBoardMemberTab.vue
// module id = null
// module chunks = 